import { omitBy, isNil, isEqual, isEmpty, cloneDeep, forEach, mapValues } from 'lodash'

/**
 * Filters mixin
 * @mixin
 */
export default {
	created() {
		this.loadFilters()
	},
	data() {
		return {
			filters: {},	// Override
			defaultFilters: {}, // Override if default applied filters is not empty
			appliedFilters: {},
		}
	},
	computed: {
		stringifiedFilters() {
			return mapValues(this.appliedFilters, filter => filter.toString())
		},
		hasFilters() {
			const filters = Object.keys(this.appliedFilters).filter(key => !['page', 'sort'].includes(key))
			return !!filters.length
		},
	},
	methods: {
		// Call to update applied filters, will set back count data to -1
		applyFilters() {
			this.appliedFilters = omitBy(this.filters, v => isNil(v) || v === '')
			if (isEqual(this.defaultFilters || {}, this.appliedFilters || {})) {
				this.appliedFilters = {}
			}

			const updated = this.saveFilters()
			if (updated && typeof this.count !== 'undefined') {
				this.count = -1
			} else if (typeof this.refresh !== 'undefined') {
				this.refresh = true
			}
		},

		loadFilters() {
			if (isEmpty(this.$route.query)) { return }
			this.appliedFilters = cloneDeep(this.$route.query)
			forEach(this.$route.query, (value, key) => {
				if (typeof this.filters[key] === 'undefined') { return }
				switch (typeof this.defaultFilters[key]) {
				case 'boolean':
					this.appliedFilters[key] = value === 'true'
					this.filters[key] = this.appliedFilters[key]
					break
				default:
					if (/^-?[0-9]+(\.[0-9]+)?$/.test(value)) {
						this.appliedFilters[key] = parseFloat(value)
						this.filters[key] = this.appliedFilters[key]
					} else {
						this.appliedFilters[key] = value
					}
				}
				this.filters[key] = this.appliedFilters[key]
			})
		},

		saveFilters() {
			if (isEqual(this.$route.query, this.appliedFilters)
				|| isEqual(this.$route.query, this.stringifiedFilters)) { return false }
			this.$router.replace({ query: this.appliedFilters })
			return true
		},
	},
}
